import BaggageIcon from './components/Baggage/BaggageIcon/BaggageIcon';
import BaggageInfo from './components/Baggage/BaggageInfo/BaggageInfo';
import { icons as azurIcons, PaymentTypes as azurPaymentTypes } from './components/FareGroup/icons/icons';
import Notification from './components/Notification/Notification';
import BaggageHeaderIcon from './components/Baggage/BaggageHeaderIcon/BaggageHeaderIcon';
import SearchFormDatepickerControls from './components/SearchFormDatepicker/SearchFormDatepickerControls/SearchFormDatepickerControls';
import FlightCardCarrierName from './components/FlightCard/FlightCardCarrierName';
import { PetInHold } from '../src/components/icons';
import { azurEquipmentIcons } from './components/HeaderEquipmentItem/icons';
import { SportEquipment } from '@websky/core';
import CheckoutServicesV2 from '@websky/core/src/Checkout/components/Checkout/ServicesV2/ServicesV2';
import CheckinServicesV2 from '@websky/core/src/Modules/Checkin/components/Checkin/AdditionalServices/AdditionalServices';
export const renderProps = {
    BaggageIcon: BaggageIcon,
    BaggageInfo: BaggageInfo,
    renderOptionIcon: type => azurIcons[type],
    renderPaymentTypeIcon: type => azurPaymentTypes[type],
    renderRetrieveBookingNotification: Notification,
    renderBaggageHeaderIcon: BaggageHeaderIcon,
    renderSearchFormDatepickerControls: SearchFormDatepickerControls,
    renderFLightCardCarrierName: FlightCardCarrierName,
    PetInHold: () => PetInHold,
    renderHeaderEquipmentIcon: rfics => (azurEquipmentIcons === null || azurEquipmentIcons === void 0 ? void 0 : azurEquipmentIcons[rfics]) || SportEquipment,
    CheckoutServices: CheckoutServicesV2,
    CheckinServices: CheckinServicesV2
};
